import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { AlertService } from './../service/alert.service';
import { User } from 'src/app/model/user.model';
import { VerificarPermissoes } from './../model/verificarPermissoes.model';
import { ClientesService } from './../service/clientes.service';
import { Router } from '@angular/router';
import { UsuariosService } from './../service/usuarios.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Cliente } from '../model/cliente.model';
import { MatDialog } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';
import { BuscaService } from './../service/busca.service';


@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit {
  public paginaAtual = 1;
  usuarios: User[] = [];
  clientes!: Cliente[];
  public clientesId!: string;
  page = 1;
  count = 0;
  pageSize = 1;
  load = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  pesquisa: any;
  parametrosPesquisa: string[] = ['vc_nome','vc_login'];

  constructor(private service: UsuariosService,
    private router: Router,
    private serviceCliente: ClientesService,
    public dialog: MatDialog,
    private alertService: AlertService,
    private buscaService: BuscaService,
  ) { }

  ngOnInit(): void {
    this.clientesId = localStorage.getItem('cliente')!;
    this.listarCliente();
  }

  listarUsuarios(): void {
    this.load = true
    this.paginaAtual = 1
    localStorage.setItem('cliente', this.clientesId)
    this.usuarios = [];
    this.service.listarServiceUsuario(this.clientesId).subscribe(resp => {
      if (resp != null) {
        if (this.clientesId != '1') {
          resp.forEach((element: any, index: any) => {
            if (element.vc_login.indexOf('teste') != -1) {
              return;
            } else if (element.vc_login.indexOf('@grupoagtech.com') != -1) {
              return;
            } else {
              this.usuarios.push(element)
            }
          });
        } else {
          resp.forEach((element: any, index: any) => {
            if (element.vc_login.indexOf('teste') != -1) {
              return;
            } else {
              this.usuarios.push(element)
            }
          });
        }
      }
      this.load = false
    }, erro => {
      if (erro.status == 401) {
        this.router.navigate(['/'])
      }
    })
  }

  finalizar(usuario: User): void {
    if (usuario.bl_status) {
      this.service.confirmAlert(usuario);
    } else {
      this.service.desativarAlert(usuario);
    }
  }

  listarCliente() {
    this.serviceCliente.listarServiceClientes().subscribe(resp => {
      this.clientes = resp;
      this.clientesId = localStorage.getItem('cliente')!;
      this.listarUsuarios();
    }, error => {
      if (error == "401") {
        localStorage.removeItem('token')
        this.router.navigate(['/'])
      }

    })
  }
  
  filtraUsuarios() {
    if(!this.pesquisa) {
      return this.usuarios;
    }
    return this.buscaService.search(this.pesquisa, this.usuarios, this.parametrosPesquisa);
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

}
